var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pt-0 pb-6"},[_c('chart',{attrs:{"options":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }